import { useAuthStore } from "~/store/auth";

// noinspection JSUnusedGlobalSymbols
export default defineNuxtRouteMiddleware(async () => {
	if (useAuthStore().user) {
		return navigateTo("/tv");
	}
});
